import { methods } from '../includes/_methods'

export const button = {
  active(){
    let btn = $('.btn-ef');
    let zoneDom = '<div data-ef-zone></div>';
    let check = function(){
      if(fesdDB.is.isMobile4 == false) return true
    }
    if(check()){
      btn.each(function(){
        let vm = $(this);
        if(!vm.hasClass('ef-active')){
          vm.addClass('ef-active');
          vm.append(zoneDom);
          $('[data-ef-zone]').css({
            'position': 'absolute',
            'left': 0,
            'top': 0,
            'width': '100%',
            'height': '100%',
            'z-index': 1
          })
          button.hover(vm);
        }
      });
    }
  },
  hover(vm){
    let zone = vm.find('[data-ef-zone]');
    zone.on('mousemove',function(e){
      let _this = $(this),
          box = _this.siblings('.box'),
          span = _this.siblings('span');
      let boxW = $('.box.in').outerWidth(),
          boxH = $('.box.in').outerHeight();
      let offset = _this.offset(),
          x = e.pageX - offset.left - (boxW / 2),
          y = e.pageY - offset.top - (boxH / 2);
      
      box.addClass('in');
      box.css({
        'left': x + 'px',
        'top': y + 'px'
      });
      span.addClass('in');
      span.css({
        'transform': `translateX(-${x / 5}px)`
      });
    }).on('mouseleave',function(){
      let _this = $(this),
          box = _this.siblings('.box'),
          span = _this.siblings('span');
      box.removeClass('in');
      // box.css({
      //   'left': 0,
      //   'top': 0
      // });
      span.removeClass('in');
      span.css({
        'transform': 'translate(0,0)'
      });
      // vm.removeClass('ef-active')
    });
  },
  // 一般按鈕動畫效果
  // animation() {
  //   let btn = $('.btn.btn-ani span');
  //   btn.each(function(i,el) {
  //     methods.wordAnimation(el, false,  0.1, 0.1)
  //   });
  // }
}
